import React, { Component } from 'react'
import app from '../../feathers'
import { injectState } from 'freactal'
import { Textfield } from 'react-mdl'

import styled from 'styled-components'

// Ensures that on focus, the underline is in the right place
const StyledTextfield = styled(Textfield)`
  .mdl-textfield__label::after{
    bottom: 0px;
  }
  .mdl-textfield__label{
    top: 8px;
    bottom: 1px;
  }
`

class SectionNameField extends Component {
  state = {
    name: this.props.name,
  }
  componentWillReceiveProps({ name }) {
    if (name !== this.state.name) {
      this.setState({ name })
    }
  }
  onClick = e => e.stopPropagation()
  onChange = ({ target }) => {
    this.setState({ name: target.value })
    this.refreshSaveTimeout()
  }
  refreshSaveTimeout = () => {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(this.save, 1500)
  }
  save = async () => {
    const { name } = this.state
    const { unitId, sectionIndex } = this.props
    const sectionPath = sectionIndex.join('.subsections.')
    await app.service('units').patch(unitId, {
      [`sections.${sectionPath}.name`]: name,
    })
  }
  render() {
    return (
      <StyledTextfield
        label="Section Name"
        value={this.state.name}
        onChange={this.onChange}
        onClick={this.onClick}
        style={this.props.style}
      />
    )
  }
}

export default injectState(SectionNameField)



// WEBPACK FOOTER //
// ./src/Units/components/SectionNameField.js